import { Action } from '@ngrx/store';
import { Calendar } from '@cemex-core/cmx-api';

export enum CalendarsActionTypes {
  LOAD_CALENDARS = '[Calendars] Load calendars',
  LOAD_CALENDARS_COMPLETE = '[Calendars] Load calendars completed',
  LOAD_FAIL_CALENDARS = '[Calendars] Load fail calendars',
  RESET = '[Calendars] Candelars reset',
  LOAD_CALENDARS_V2 = '[Calendars] Load calendars V2',
}

export class LoadCalendarsAction implements Action {
  readonly type = CalendarsActionTypes.LOAD_CALENDARS;

  constructor() {}
}

export class LoadCalendarsV2Action implements Action {
  readonly type = CalendarsActionTypes.LOAD_CALENDARS_V2;

  constructor() {}
}

export class LoadCalendarsCompleteAction implements Action {
  readonly type = CalendarsActionTypes.LOAD_CALENDARS_COMPLETE;

  constructor(public payload: Calendar[]) {}
}

export class LoadFailCalendarsAction implements Action {
  readonly type = CalendarsActionTypes.LOAD_FAIL_CALENDARS;

  constructor() {}
}

export class ResetCalendarsAction implements Action {
  readonly type = CalendarsActionTypes.RESET;

  constructor() {}
}

export type CalendarsActions =
  | LoadCalendarsAction
  | LoadCalendarsCompleteAction
  | LoadFailCalendarsAction
  | ResetCalendarsAction
  | LoadCalendarsV2Action;
